"use strict";
exports.__esModule = true;
var depth = {
    inset: {
        boxShadow: 'inset 0px 0px 8px 0 rgba(82, 97, 115, 0.09)'
    },
    1: { boxShadow: '0px 2px 4px 0 rgba(0, 0, 0, 0.08)' },
    2: { boxShadow: '0px 4px 8px 0 rgba(0, 0, 0, 0.1)' },
    3: { boxShadow: '0px 8px 16px 0 rgba(0, 0, 0, 0.12)' },
    4: {
        border: '1px solid rgba(218, 226, 230, 1)',
        boxShadow: '0px 8px 16px 0 rgba(0, 0, 0, 0.12)'
    }
};
exports["default"] = depth;
